/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/paymentrequests/create')({
  beforeLoad: () => {
    throw redirect({
      to: '/admin/payments/create',
      statusCode: StatusCodes.MOVED_PERMANENTLY,
    })
  },
})
